import { render, staticRenderFns } from "./CompanyDataRegister.vue?vue&type=template&id=10118f20&scoped=true&"
import script from "./CompanyDataRegister.vue?vue&type=script&lang=js&"
export * from "./CompanyDataRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataRegister.vue?vue&type=style&index=0&id=10118f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10118f20",
  null
  
)

export default component.exports